AFRAME.registerComponent('chart-type-control', {
    schema: {
        width: { type: 'number', default: 5.8 },
        height: { type: 'number', default: 0.95 },
        depth: { type: 'number', default: 0.1 },
        color: { type: 'string', default: '#111111' },
        buttonColor: { type: 'string', default: '#191920' },
        hoverColor: { type: 'string', default: '#2B2B32' },
        selectedColor: { type: 'string', default: '#3636E3' },
        selectedPrimeAction: { type: 'string', default: 'topdollar' },
        selectedSecondaryAction: { type: 'string', default: 'sec' }
    },

    init: function () {
        this.defaultSelectLabel = ''
        this.selectedButton = null;
        this.scene = document.querySelector('a-scene');
        this.chartTypeContainer = this.el.querySelector('.chart-types-container')
        this.buttons = [];
        this.interactivePlanes = [];
        this.selectedButton3DFrame = null

        try {
            const cached = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
            if (cached && cached.includes(':')) {
                const [prime, secondary] = cached.split(':');
                this.el.setAttribute('chart-type-control', {
                    selectedPrimeAction: prime,
                    selectedSecondaryAction: secondary
                });
            }
        } catch (e) {
            console.warn('[ChartTypeControl] Failed to load persistent state', e);
        }

        // this.createButtons();
        this.setListeners();
        this.init3DFrame()
        this.createInteractivePlane();

        this.el.sceneEl.addEventListener('search-dropdown-toggled', (e) => {
            if (!e.detail) return;
            if (e.detail.visible) {
                this.interactivePlanes.forEach(plane => plane.removeAttribute('data-raycastable'));
            } else {
                this.interactivePlanes.forEach(plane => plane.setAttribute('data-raycastable', ''));
            }
        });
    },


    setListeners: function () {
        this.el.addEventListener('change-secondary-action', (e) => {
            console.log('change-secondary-action event received', e)
            const isActive = e.detail?.isActive;
            this.el.setAttribute('chart-type-control', 'selectedSecondaryAction', isActive ? 'sec' : 'gen');
            this.updateChartType(false)
        })
    },

    updateChartType: function (shouldResetSectors = true) {
        if (window.VRPanelsSlidingManager) {
            window.VRPanelsSlidingManager.setSelectedEl(null);
        }

        const action = this.el.getAttribute('chart-type-control')?.selectedPrimeAction;

        const searchPanel = document.querySelector('#search-center-panel');
        let isSearchActive = false;
        if (searchPanel) {
            const pos = searchPanel.getAttribute('position');
            const posY = pos ? (typeof pos === 'string' ? parseFloat(pos.split(' ')[1]) : pos.y) : 12.2;
            isSearchActive = posY < 5.0;
        }

        if (isSearchActive) {
            const searchModeEl = document.querySelector('[search-mode]');
            if (searchModeEl && searchModeEl.components && searchModeEl.components['search-mode']) {
                searchModeEl.components['search-mode'].exitSearchMode(action);
            }
        }

        const infoPopup = document.querySelector('#info-popup');
        if (infoPopup) {
            if (infoPopup.components && infoPopup.components['info-popup']) {
                try {
                    infoPopup.components['info-popup'].close();
                } catch (error) {
                    console.warn('chart-type-control: Error closing info popup:', error);
                    infoPopup.setAttribute('visible', false);
                }
            } else {
                infoPopup.setAttribute('visible', false);
            }
        }

        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel) {
            let centerContent = document.getElementById('large-center-panel-content');
            if (centerContent) {
                centerContent.replaceChildren();
                centerContent.setAttribute('position', '0 0 0');
            }
        }

        let secondaryTypeAction = this.el.getAttribute('chart-type-control')?.selectedSecondaryAction

        if (shouldResetSectors) {
            try {
                const sectorsControl = document.querySelector('#sectors-control');
                if (sectorsControl && sectorsControl.components['sectors-control']) {
                    const state = sectorsControl.components['sectors-control'].loadState(action);
                    if (state) {
                        const syncSecondary = state.sectorsBreaks ? 'sec' : 'gen';
                        if (syncSecondary !== secondaryTypeAction) {
                            secondaryTypeAction = syncSecondary;
                            this.el.setAttribute('chart-type-control', 'selectedSecondaryAction', secondaryTypeAction);
                        }
                    }
                }
            } catch (e) {
                console.warn('[ChartTypeControl] Failed to sync secondary action from sectors-control', e);
            }
        }
        try {
            if (action !== 'watchlist-reports' && typeof setCacheItem !== 'undefined') {
                const expiration = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
                setCacheItem('lastChartType', `${action}:${secondaryTypeAction}`, expiration);
                console.log('[ChartTypeControl] Saved lastChartType:', action, secondaryTypeAction);
            }
        } catch (e) {
            console.warn('[ChartTypeControl] Failed to save lastChartType', e);
        }

        if (action !== 'watchlist-reports') {
            this.el.sceneEl.emit('watchlist-main-empty-state', { active: false });
        }

        if (typeof renderStockChartByAction === 'function') {
            renderStockChartByAction(action, secondaryTypeAction);
        } else {
            console.warn('renderStockChartByAction not found, falling back to inline logic');
            if (action === 'gainers' && secondaryTypeAction === 'gen') addStockGainersToCenterPanel();
            if (action === 'gainers' && secondaryTypeAction === 'sec') addStockGainersSectorToCenterPanel();
            if (action === 'losers' && secondaryTypeAction === 'gen') addStockLosersToCenterPanel();
            if (action === 'losers' && secondaryTypeAction === 'sec') addStockLosersSectorToCenterPanel();
            if (action === 'topvol' && secondaryTypeAction === 'gen') addStockByVolRankCubeToCenterPanel();
            if (action === 'topvol' && secondaryTypeAction === 'sec') addStockByVolCubeToCenterPanel();
            if (action === 'topdollar' && secondaryTypeAction === 'gen') addStockTopDollarCubeToCenterPanel();
            if (action === 'topdollar' && secondaryTypeAction === 'sec') addStockTopDollarSectorCubeToCenterPanel();
            if (action === 'sip' && secondaryTypeAction === 'gen') addShortInterestCubeToCenterPanel();
            if (action === 'sip' && secondaryTypeAction === 'sec') addShortInterestSectorCubeToCenterPanel();
            if (action === 'dividend' && secondaryTypeAction === 'gen') addDividendCubeToCenterPanel();
            if (action === 'dividend' && secondaryTypeAction === 'sec') addDividendSectorCubeToCenterPanel();
            if (action === 'mmap') addMarketMapCubeToCenterPanel();
            if (action === 'watchlist-reports') {
                addWatchlistReportsCubeToCenterPanel();
            }
        }

        const stockChart = document.querySelector('#stock-chart');
        const noSelectedStockMessage = document.querySelector('#no-selected-stock-message');
        const stockWrapper = document.querySelector('#stock-wrapper');
        if (!stockChart || !noSelectedStockMessage || !stockWrapper) return
        const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
        if (!existingUniversal) return
        const stockData = existingUniversal.stockData
        const ticker = JSON.parse(stockData)?.ticker || null
        console.log('ks ticker', ticker, noSelectedStockMessage)
        if (ticker === 'SPY') {
            noSelectedStockMessage.setAttribute('visible', action === 'dividend');
            stockWrapper.setAttribute('visible', action !== 'dividend');

        }
        this.el.sceneEl.emit('data-interval-dividend', { interval: (action === 'dividend' || action === 'sip') ? '1Y' : '1D' });
        let secondarySeriesType = 'volume';
        if (action === 'dividend') secondarySeriesType = 'dividend';
        if (action === 'sip') secondarySeriesType = 'sip';

        stockChart.setAttribute('tradingview-universal-chart', 'secondarySeriesType', secondarySeriesType);

        this.el.sceneEl.emit('chart-type-changed', { action: action });
    },


    init3DFrame: function () {
        const setFrameModel = (obj) => {
            obj.traverse((child) => {
                if (child.name === "BottomFrame") {
                    this.selectedButton3DFrame = child;

                    const action = this.data.selectedPrimeAction;
                    const properties = [
                        { action: 'topdollar', framePosX: -12.4},
                        { action: 'gainers', framePosX: -8.7 },
                        { action: 'losers', framePosX: -5.5 },
                        { action: 'topvol', framePosX: -2.3 },
                        { action: 'dividend', framePosX: 0.9 },
                        { action: 'sip', framePosX: 4.8  },
                        { action: 'mmap', framePosX: 9.1  },
                        { action: 'watchlist-reports', framePosX: 12.8 },
                    ];
                    const prop = properties.find(p => p.action === action);
                    if (prop) {
                        this.selectedButton3DFrame.position.x = prop.framePosX * 1.12
                        this.selectedButton3DFrame.visible = true;
                    } else {
                        this.selectedButton3DFrame.visible = false;
                    }
                }
            });
        }
        
        const model = this.el.querySelector('.model-3d')
        let mesh = null
        if (model) {
            mesh = model.getObject3D('mesh');
            if (mesh) {
                setFrameModel(mesh)
            } else {
                model.addEventListener('model-loaded', () => {
                    mesh = model.getObject3D('mesh');
                    if (mesh) setFrameModel(mesh);
                })
            }
        }
    },

    createInteractivePlane: function () {
        if (!this.chartTypeContainer) return

        const properties = [
            { action: 'topdollar', framePosX: -12.4, label: 'Top $ Volume', labelShift: -0.2 },
            { action: 'gainers', framePosX: -8.7, label: 'Gainers' },
            { action: 'losers', framePosX: -5.5, label: 'Losers'},
            { action: 'topvol', framePosX: -2.3, label: 'Volume' },
            { action: 'dividend', framePosX: 0.9, label: 'Dividends' },
            { action: 'sip', framePosX: 4.8, label: 'Short Interest', labelShift: 0.05 },
            { action: 'mmap', framePosX: 9.1, label: 'Market Map', labelShift: 0.1 },
            { action: 'watchlist-reports', framePosX: 12.8, label: 'Watchlist', labelShift: 0.2 },
        ]

        const buttonWidth = 3;
        const buttonHeight = 1.6
        const z = 0.01;


        properties.forEach((property, index) => {
            const x = property.framePosX
            const y = 0
            
            const interactivePlane = document.createElement('a-plane');
            interactivePlane.setAttribute('width', buttonWidth)
            interactivePlane.setAttribute('height', buttonHeight)
            interactivePlane.setAttribute('opacity', `0`)
            interactivePlane.setAttribute('data-action', property.action);
            interactivePlane.setAttribute('data-raycastable', ``)
            interactivePlane.setAttribute('position', `${x} ${y} ${z}`)
            if (property.action === 'topdollar') interactivePlane.classList.add('default-chart');
            this.chartTypeContainer.appendChild(interactivePlane);
            this.interactivePlanes.push(interactivePlane);

            interactivePlane.addEventListener('click', async () => {

                if (property.action === 'watchlist-reports') {
                    const manager = window.WatchlistApp && window.WatchlistApp.Manager;
                    if (manager && manager.checkAuthorization) {
                        const result = await manager.checkAuthorization();
                        if (!result.authorized) {
                            if (window.AuthUI && window.AuthUI.showMessage) {
                                window.AuthUI.showMessage(result.message);
                            } else {
                                console.warn('AuthUI not available to show message:', result.message);
                            }
                            return;
                        }
                    }
                }

                const currentAction = this.el.getAttribute('chart-type-control')?.selectedPrimeAction;
                if (property.action === currentAction && property.action === 'watchlist-reports') {
                    const switchEl = document.querySelector('[switch-table-chart]');
                    if (switchEl && switchEl.components['switch-table-chart']) {
                        switchEl.components['switch-table-chart'].switchToChart();
                    }
                    return;
                }
                
                if (this.selectedButton3DFrame) {
                    this.selectedButton3DFrame.position.x = property.framePosX * 1.12
                    this.selectedButton3DFrame.visible = true;

                    this.el.setAttribute('chart-type-control', 'selectedPrimeAction', property.action);

                    if (window.gtag) {
                        const prettyName = {
                            topdollar: "TopDollar",
                            gainers: "Gainers",
                            losers: "Losers",
                            topvol: "Volume",
                            dividend: "Dividend",
                            sip: "ShortInterest",
                            mmap: "Marketmap",
                            "watchlist-reports": "Watchlist",
                        }

                        gtag('event', `VR_TopNav_${prettyName[property.action] || null}`);
                    }
                    
                    this.updateChartType()
                }
            })
            
            // 2d titles
            const titleEl = document.createElement('a-text');
            titleEl.setAttribute('position', `${x + (property.labelShift || 0)} ${y} 0.02`)
            titleEl.setAttribute('value', property.label)
            titleEl.setAttribute('scale', '2.3 2.3 2.3')
            titleEl.setAttribute('align', 'center')
            titleEl.classList.add('chart-type-title')
            this.chartTypeContainer.appendChild(titleEl);            
        })


    },

    checkIfChartNotBlocked() {
        const configureControlElement = document.querySelector('#configure-control');
        const configureControlAttr = configureControlElement ? configureControlElement.getAttribute('configure-control') : null;

        return !!(configureControlAttr && configureControlAttr.position === 'Manual')
    },

    show: function () {
        this.el.setAttribute('visible', true);
        this.buttons.forEach(btn => btn.setAttribute('data-raycastable', ''));
        this.interactivePlanes.forEach(plane => plane.setAttribute('data-raycastable', ''));
    },

    hide: function () {
        this.el.setAttribute('visible', false);
        this.buttons.forEach(btn => btn.removeAttribute('data-raycastable'));
        this.interactivePlanes.forEach(plane => plane.removeAttribute('data-raycastable'));
    },

    clearSelection: function () {
        this.el.setAttribute('chart-type-control', 'selectedPrimeAction', '');
        if (this.selectedButton3DFrame) {
            this.selectedButton3DFrame.visible = false;
        }
    }

});
